import React, { useEffect } from 'react';
import { useField } from 'formik';
import useCountdownTimer from 'app/core/hooks/useCountdownTimer';
import Input from 'app/common/components/Elements/Input';
import { OTPFieldProps } from './types';

const OTPField: React.FC<OTPFieldProps> = ({ label, wrapClassName, duration, startTimerRef, onResend, ...props }) => {
  const [field, meta, helpers] = useField(props.name);
  const countdownTimer = useCountdownTimer(duration);

  useEffect(() => {
    if (document.getElementsByName('otpCode')[0]) {
      document.getElementsByName('otpCode')[0].focus();
    }
  }, []);

  /**
   * @description 啟用倒數計時
   */
  useEffect(() => {
    if (startTimerRef) countdownTimer.start();
    return () => { countdownTimer.cleanup(); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTimerRef]);

  /**
   * @description 處理重新發送
   */
  const handleResend = () => {
    if (onResend) onResend();
    helpers.setValue('');
    document.getElementsByName('otpCode')[0].focus();
  };

  return (
    <div className={'form-row w-100' + (wrapClassName ? ` ${wrapClassName}` : '')}>
      <div className="wrapper">
        <div className="name">{label}</div>
        <div className="d-flex align-items-center">
          <Input
            {...field}
            {...props}
            type="text"
            className={'form-control me-2' + (meta.error && meta.touched ? ' field--invalid' : '')}
            placeholder="6 位數字"
          />
          <button
            tabIndex={props.tabIndex}
            type="button"
            className={'btn btn-outline-primary px-2 text-nowrap send-btn' + (!countdownTimer.done ? ' send-disabled' : '')}
            onClick={handleResend}
            disabled={!countdownTimer.done}
          >
            重新發送
          </button>
        </div>
        {meta.error && meta.touched && (
          <div className="notes warn mt-2">{meta.error}</div>
        )}
      </div>
    </div>
  );
};

export default OTPField;
